import { defineMessages } from 'react-intl';

const messages = defineMessages({
  snapshotView: {
    id: 'snapshotView',
    defaultMessage: 'Snapshot View',
  },
  topic: {
    id: 'topic',
    defaultMessage: 'Topic',
  },
  dataPromptTitle: {
    id: 'dataPromptTitle',
    defaultMessage: 'Pick data',
  },
  dataPromptBody: {
    id: 'dataPromptBody',
    defaultMessage: 'Pick what data to view',
  },
  expectedturnoverrevenueOption: {
    id: 'expectedturnoverrevenueOption',
    defaultMessage: 'Expected Net Turnover Revenue',
  },
  expectedturnoverrevenuem2Option: {
    id: 'expectedturnoverrevenuem2Option',
    defaultMessage: 'Expected Net Turnover Revenue / m²',
  },
  commercialefficiencyOption: {
    id: 'commercialefficiencyOption',
    defaultMessage: 'Commercial Efficiency',
  },
  densityandfillingrateOption: {
    id: 'densityandfillingrateOption',
    defaultMessage: 'Density & Filling Rate',
  },
  expandAll: {
    id: 'expandAll',
    defaultMessage: 'Expand all',
  },
  collapseAll: {
    id: 'collapseAll',
    defaultMessage: 'Collapse all',
  },
  spaceNeed: {
    id: 'spaceNeed',
    defaultMessage: 'Space Need',
  },
  spaceUtilization: {
    id: 'spaceUtilization',
    defaultMessage: 'Space Utilization',
  },

  // Space Need
  backpanelNeed: {
    id: 'maintainResultTableHeaderBackpanelNeed',
    defaultMessage: 'Backpanel Need',
    description: 'Header for Space Need table, column BackpanelNeed',
  },
  backpanelUtilization: {
    id: 'maintainResultTableHeaderBackpanelUtilization',
    defaultMessage: 'Backpanel Utilization',
    description:
      'Header for Space Utilization table, column BackpanelUtilization',
  },
  halfPalletNeed: {
    id: 'maintainResultTableHeaderHalfPalletNeed',
    defaultMessage: 'Half Pallet Need',
    description: 'Header for Space Need table, column HalfPalletNeed',
  },
  halfPalletUtilization: {
    id: 'maintainResultTableHeaderHalfPalletUtilization',
    defaultMessage: 'Half Pallet Utilization',
    description:
      'Header for Space Utilization table, column HalfPalletUtilization',
  },
  fullPalletNeed: {
    id: 'maintainResultTableHeaderFullPalletNeed',
    defaultMessage: 'Full Pallet Need',
    description: 'Header for Space Need table, column FullPalletNeed',
  },
  fullPalletUtilization: {
    id: 'maintainResultTableHeaderFullPalletUtilization',
    defaultMessage: 'Full Pallet Utilization',
    description:
      'Header for Space Utilization table, column FullPalletUtilization',
  },
  longPalletNeed: {
    id: 'maintainResultTableHeaderLongPalletNeed',
    defaultMessage: 'Long Pallet Need',
    description: 'Header for Space Need table, column LongPalletNeed',
  },
  longPalletUtilization: {
    id: 'maintainResultTableHeaderLongPalletUtilization',
    defaultMessage: 'Long Pallet Utilization',
    description:
      'Header for Space Utilization table, column LongPalletUtilization',
  },
  handstackLocationNeed: {
    id: 'maintainResultTableHeaderHandstackLocationNeed',
    defaultMessage: 'Handstack Location Need',
    description: 'Header for Space Need table, column HandstackLocationNeed',
  },
  handstackLocationUtilization: {
    id: 'maintainResultTableHeaderHandstackLocationUtilization',
    defaultMessage: 'Handstack Location Utilization',
    description:
      'Header for Space Utilization table, column HandstackLocationUtilization',
  },

  // Commercial effiency
  directFlowPercentage: {
    id: 'directFlowPercentage',
    defaultMessage: 'Direct Flow (%)',
  },
  rssqFfPercentage: {
    id: 'rssqFfPercentage',
    defaultMessage: 'RSSQ FF (%)',
  },
  movesSoldM3: {
    id: 'maintainSortMovesPerSoldM3',
    defaultMessage: 'Moves per sold m³',
    description: 'Moves per sold cubic meter',
  },
  unplanned: {
    id: 'unplanned',
    defaultMessage: 'Unplanned',
    description: 'Unplanned article status',
  },
  underMinSsq: {
    id: 'underMinSsq',
    defaultMessage: 'Under Min SSQ',
  },
  overMaxSsq: {
    id: 'overMaxSsq',
    defaultMessage: 'Over Max SSQ',
  },
  numLocalLocal: {
    id: 'numLocalLocal',
    defaultMessage: 'Num Local Local',
  },
  overstock: {
    id: 'overstock',
    defaultMessage: 'Overstock',
  },
  limitedSupply: {
    id: 'limitedSupply',
    defaultMessage: 'Limited Supply',
  },
  noSupply: {
    id: 'noSupply',
    defaultMessage: 'No Supply',
  },
  smdq: {
    id: 'smdq',
    defaultMessage: 'SMDQ',
    description: 'Small Store Minimum Delivery Quantity',
  },
  rtsImpl: {
    id: 'rtsImpl',
    defaultMessage: 'RTS Impl.',
  },
  flexAvg: {
    id: 'flexAvg',
    defaultMessage: 'Flex Avg.',
  },
  flexShare: {
    id: 'flexShare',
    defaultMessage: 'Flex Share',
  },
  expNetTurnRev: {
    id: 'expNetTurnRev',
    defaultMessage: 'Exp.Net Turn Rev.',
  },
  expNetTurnRevM2: {
    id: 'expNetTurnRevM2',
    defaultMessage: 'Exp.Net Turn Rev.m2',
  },

  // Density and filling rate
  area: {
    id: 'area',
    defaultMessage: 'Area (m2)',
  },
  plannedVolume: {
    id: 'plannedVolume',
    defaultMessage: 'Planned Volume (m3)',
  },
  ssqVolume: {
    id: 'ssqVolume',
    defaultMessage: 'SSQ Volume',
  },
  actualVolume: {
    id: 'actualVolume',
    defaultMessage: 'Actual Volume (m3)',
  },
  plannedMaxDensity: {
    id: 'plannedMaxDensity',
    defaultMessage: 'Planned Max Density',
  },
  maxDensity: {
    id: 'maxDensity',
    defaultMessage: 'Max Density',
  },
  plannedFillingRate: {
    id: 'plannedFillingRate',
    defaultMessage: 'Planned Filling Rate (%)',
  },
  fillingRate: {
    id: 'fillingRate',
    defaultMessage: 'Filling Rate (%)',
  },
  plannedDensity: {
    id: 'plannedDensity',
    defaultMessage: 'Planned Density',
  },
  actualDensity: {
    id: 'actualDensity',
    defaultMessage: 'Actual Density',
  },
});

export default messages;
